import { Component } from '@angular/core';
import { environment } from './../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef } from '@angular/core';
import { debounceTime, distinctUntilChanged, Subject, switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-ngx-table-format',
  templateUrl: './ngx-table-format.component.html',
  styleUrls: ['./ngx-table-format.component.scss']
})
export class NgxTableFormatComponent {
  pageSize = 20;
  sortType:string = 'desc';
  sorts = [{ prop: 'name', dir: this.sortType }];
  rows = [];
  editData;
  columns = [
    // { prop: 'null', name: 'Select', checkboxable: true, sortable: false },
    { prop: 'first_name', name: 'First Name' },
    { prop: 'last_name', name: 'Last Name' },
    { prop: 'default_identity.email', name: 'Email' },
    { prop: 'non_admin_unassgined_teams_count', name: 'Teams', sortable: false },
    // { prop: 'null', name: 'Action', sortable: false },
  ];
  totalRecords = 0;
  currentPage = 0;
  meta:any;
  queryType:string = 'last_name_order';
  searchQuery:string;
  private searchSubject = new Subject<string>();
  searchby:string = 'first_name';
  selectedRows: any[] = [];   // To hold selected rows
  selectAll: boolean = false;  // To check if all rows are selected

  constructor(private http: HttpClient,private cdr: ChangeDetectorRef) { }


  ngOnInit() {
    this.fetchData(this.currentPage, this.pageSize);
    this.searchSubject.pipe(
      debounceTime(500),  // Wait for 500ms after the last keystroke
      distinctUntilChanged(),  // Only trigger if the query actually changes
      switchMap((query) => this.getSearchData(query))
    ).subscribe();
  }

  onSort(event) {
    console.log('sort event', event)
    this.sortType = event.newValue;
    if(event.column.prop == 'first_name') {
      this.queryType = 'first_name_order';
    }else if(event.column.prop == 'last_name') {
      this.queryType = 'last_name_order';
    }else if(event.column.prop == 'email') {
      this.queryType = 'email_order';
    }
    this.fetchData(this.currentPage, this.pageSize);
  }


  fetchData(page: number, size: number) {
    const url = `${environment.profileURL}/api/v1/organizations/40486/members.json?per_page=${size}&page=${page+1}&${this.queryType}=${this.sortType}`; 
    return this.http.get<any>(url).subscribe(response => {
      console.log(response);
      this.meta = response.meta;
        this.totalRecords = this.meta.total_count;
        this.rows = response.members;
        this.selectAll = false;
      console.log(this.rows);
      this.cdr.detectChanges(); 
    });
  }

  onPage(event: any) {
    console.log('event',event)
    this.currentPage = event.offset; // event.offset is the page number (0-based)
    this.pageSize = event.limit;     // event.limit is the page size
    this.fetchData(this.currentPage, this.pageSize);
  }

 // Triggered on search input change
  onSearch(query: string) {
    this.searchSubject.next(query);  // Pass the query to the subject
  }

  getSearchData(value) {
    const url = `${environment.profileURL}/api/v1/organizations/40486/members.json?per_page=${this.pageSize}&page=${this.currentPage+1}&${this.queryType}=${this.sortType}&${this.searchby}=${value}`; 
    return this.http.get<any>(url).pipe(
      tap(response => {
        this.rows = response.members;
        this.totalRecords = response.meta.total_count;
      })
    );
  }
  
    // Handle row selection
  onRowSelect(event: any, row:any) {
    console.log('row selected event', event, row)
    this.selectedRows = event.selected;
    this.checkIfAllSelected();
  }

  // Handle "Select All" checkbox click
  toggleSelectAll() {
    if (this.selectAll) {
      // Select all rows on the current page
      this.selectedRows = [...this.rows];
      this.rows.forEach(row => row.selected = true);
    } else {
      // Deselect all rows on the current page
      this.selectedRows = [];
      this.rows.forEach(row => row.selected = false);
    }
  }

  // Check if all rows are selected
  checkIfAllSelected() {
    this.selectAll = this.selectedRows.length === this.rows.length;
  }

    // Edit Row
  editRow(row: any) {
    console.log('Editing row', row);
    this.editData = row;
  }

  // Delete Row
  deleteRow(row: any) {
    console.log('Deleting row', row);
  }

  receiveFromChild(msg: string) {
    console.log('msg',msg)
    this.editData = msg;
  }
  
}
